<!-- Home Page Main Top Container -->
<div class="row no-gutters home-card">

  <div class="col-md-6 container website_animation home-intro-first">

    <!-- Homepage Title Section -->
    <!-- <div class="container">
        <p class="cp1">シ Project <strong class="title-highlight" style="font-family: Sacramento;">Elixir</strong> </p>
        <p class="cp2" style="font-family: cursive;">⊀ Unleash Innovation ⊁</p>

        <p class="intro-sum">Redefine Simplicity with your android experience on our minimalistic custom rom — where
          sleek design meets robust security, performance, and stability. Elevate your user interface with minimalist
          design and with the striking of perfect balanced customization options, customize with ease.
        </p>

        <footer class="blockquote-footer"> Due to toxicity in community <strong style="color: #e77d5a;">all
            builds will be exclusive to Patreon/BMC</strong> only</footer>
        <footer class="blockquote-footer"> We have support for more than 70+ devices based on Android 15</footer>
        <footer class="blockquote-footer"> For any further queries contact us via mail or on Telegram.</footer>

        <br>
        <br>

        <div class="list-unstyled list-inline">
          <a href="https://projectelixiros.com/download">
            <svg width="46" height="46" fill="#000000" class="bi bi-telegram " viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM13 8C13 7.44772 12.5523 7 12 7C11.4477 7 11 7.44772 11 8L11 13.5858L9.70711 12.2929C9.31658 11.9024 8.68342 11.9024 8.29289 12.2929C7.90237 12.6834 7.90237 13.3166 8.29289 13.7071L11.2059 16.6201C11.2209 16.6351 11.2363 16.6497 11.252 16.6637C11.4352 16.87 11.7024 17 12 17C12.2976 17 12.5648 16.87 12.748 16.6637C12.7637 16.6497 12.7791 16.6351 12.7941 16.6201L15.7071 13.7071C16.0976 13.3166 16.0976 12.6834 15.7071 12.2929C15.3166 11.9024 14.6834 11.9024 14.2929 12.2929L13 13.5858L13 8Z"
                fill="#000000" />
            </svg></a>

          <a href="https://www.paypal.me/uglykid24"> <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38"
              fill="#000000" class="bi bi-paypal footer_logo_icons" viewBox="0 0 16 16">
              <path
                d="M14.06 3.713c.12-1.071-.093-1.832-.702-2.526C12.628.356 11.312 0 9.626 0H4.734a.7.7 0 0 0-.691.59L2.005 13.509a.42.42 0 0 0 .415.486h2.756l-.202 1.28a.628.628 0 0 0 .62.726H8.14c.429 0 .793-.31.862-.731l.025-.13.48-3.043.03-.164.001-.007a.351.351 0 0 1 .348-.297h.38c1.266 0 2.425-.256 3.345-.91.379-.27.712-.603.993-1.005a4.942 4.942 0 0 0 .88-2.195c.242-1.246.13-2.356-.57-3.154a2.687 2.687 0 0 0-.76-.59l-.094-.061ZM6.543 8.82a.695.695 0 0 1 .321-.079H8.3c2.82 0 5.027-1.144 5.672-4.456l.003-.016c.217.124.4.27.548.438.546.623.679 1.535.45 2.71-.272 1.397-.866 2.307-1.663 2.874-.802.57-1.842.815-3.043.815h-.38a.873.873 0 0 0-.863.734l-.03.164-.48 3.043-.024.13-.001.004a.352.352 0 0 1-.348.296H5.595a.106.106 0 0 1-.105-.123l.208-1.32.845-5.214Z" />
            </svg> </a>

          <a href="https://twitter.com/Projectelixiros"> <svg xmlns="http://www.w3.org/2000/svg"
              shape-rendering="geometricPrecision" width="34" height="34" class="bi bi-paypal footer_logo_iconsX"
              text-rendering="geometricPrecision" image-rendering="optimizeQuality" fill-rule="evenodd"
              clip-rule="evenodd" viewBox="0 0 512 462.799">
              <path fill-rule="nonzero"
                d="M403.229 0h78.506L310.219 196.04 512 462.799H354.002L230.261 301.007 88.669 462.799h-78.56l183.455-209.683L0 0h161.999l111.856 147.88L403.229 0zm-27.556 415.805h43.505L138.363 44.527h-46.68l283.99 371.278z" />
            </svg></a>

          <a href="https://www.buymeacoffee.com/Uglykid">
            <svg width="38" height="38" fill="#000000" class="bi footer_logo_icons" viewBox="0 0 24 24" role="img"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="m20.216 6.415-.132-.666c-.119-.598-.388-1.163-1.001-1.379-.197-.069-.42-.098-.57-.241-.152-.143-.196-.366-.231-.572-.065-.378-.125-.756-.192-1.133-.057-.325-.102-.69-.25-.987-.195-.4-.597-.634-.996-.788a5.723 5.723 0 0 0-.626-.194c-1-.263-2.05-.36-3.077-.416a25.834 25.834 0 0 0-3.7.062c-.915.083-1.88.184-2.75.5-.318.116-.646.256-.888.501-.297.302-.393.77-.177 1.146.154.267.415.456.692.58.36.162.737.284 1.123.366 1.075.238 2.189.331 3.287.37 1.218.05 2.437.01 3.65-.118.299-.033.598-.073.896-.119.352-.054.578-.513.474-.834-.124-.383-.457-.531-.834-.473-.466.074-.96.108-1.382.146-1.177.08-2.358.082-3.536.006a22.228 22.228 0 0 1-1.157-.107c-.086-.01-.18-.025-.258-.036-.243-.036-.484-.08-.724-.13-.111-.027-.111-.185 0-.212h.005c.277-.06.557-.108.838-.147h.002c.131-.009.263-.032.394-.048a25.076 25.076 0 0 1 3.426-.12c.674.019 1.347.067 2.017.144l.228.031c.267.04.533.088.798.145.392.085.895.113 1.07.542.055.137.08.288.111.431l.319 1.484a.237.237 0 0 1-.199.284h-.003c-.037.006-.075.01-.112.015a36.704 36.704 0 0 1-4.743.295 37.059 37.059 0 0 1-4.699-.304c-.14-.017-.293-.042-.417-.06-.326-.048-.649-.108-.973-.161-.393-.065-.768-.032-1.123.161-.29.16-.527.404-.675.701-.154.316-.199.66-.267 1-.069.34-.176.707-.135 1.056.087.753.613 1.365 1.37 1.502a39.69 39.69 0 0 0 11.343.376.483.483 0 0 1 .535.53l-.071.697-1.018 9.907c-.041.41-.047.832-.125 1.237-.122.637-.553 1.028-1.182 1.171-.577.131-1.165.2-1.756.205-.656.004-1.31-.025-1.966-.022-.699.004-1.556-.06-2.095-.58-.475-.458-.54-1.174-.605-1.793l-.731-7.013-.322-3.094c-.037-.351-.286-.695-.678-.678-.336.015-.718.3-.678.679l.228 2.185.949 9.112c.147 1.344 1.174 2.068 2.446 2.272.742.12 1.503.144 2.257.156.966.016 1.942.053 2.892-.122 1.408-.258 2.465-1.198 2.616-2.657.34-3.332.683-6.663 1.024-9.995l.215-2.087a.484.484 0 0 1 .39-.426c.402-.078.787-.212 1.074-.518.455-.488.546-1.124.385-1.766zm-1.478.772c-.145.137-.363.201-.578.233-2.416.359-4.866.54-7.308.46-1.748-.06-3.477-.254-5.207-.498-.17-.024-.353-.055-.47-.18-.22-.236-.111-.71-.054-.995.052-.26.152-.609.463-.646.484-.057 1.046.148 1.526.22.577.088 1.156.159 1.737.212 2.48.226 5.002.19 7.472-.14.45-.06.899-.13 1.345-.21.399-.072.84-.206 1.08.206.166.281.188.657.162.974a.544.544 0 0 1-.169.364zm-6.159 3.9c-.862.37-1.84.788-3.109.788a5.884 5.884 0 0 1-1.569-.217l.877 9.004c.065.78.717 1.38 1.5 1.38 0 0 1.243.065 1.658.065.447 0 1.786-.065 1.786-.065.783 0 1.434-.6 1.499-1.38l.94-9.95a3.996 3.996 0 0 0-1.322-.238c-.826 0-1.491.284-2.26.613z" />
            </svg>
          </a>


          <a href="https://github.com/Project-Elixir"> <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40"
              fill="#000000" class="bi footer_logo_icons " viewBox="0 0 16 16">
              <path
                d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.012 8.012 0 0 0 16 8c0-4.42-3.58-8-8-8z" />
            </svg> </a>

        </div>

        <br>

      </div> -->

    <!-- Homepage Intro Buttons -->
    <!-- <div class="container">

        <h1 class="home-intro-btn"> <a href="https://projectelixiros.com/faq">
            <a class="btn footer-support-btn" style="letter-spacing: 2px;">
              Learn More about us <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="bi logo_icons"
                height="40" width="40">
                <path
                  d="m18.707 12.707-3 3a1 1 0 0 1-1.414-1.414L15.586 13H6a1 1 0 0 1 0-2h9.586l-1.293-1.293a1 1 0 0 1 1.414-1.414l3 3a1 1 0 0 1 0 1.414z"
                  style="fill:hsl(0, 0%, 100%)" data-name="Right" />
              </svg></a>
          </a></h1>

      </div>

    </div> -->

    <br>
    <br>
    <br>

    <p class="intro-heading" style="margin-top: 1rem;"> シ Project <strong class="title-highlight">Elixir</strong></p>
    <p class="intro-sum" style="margin-top: -1.5rem;">Based on Android Open Source Project</p>

    <br>
    <p class="cp2">⊀ Unleash Innovation ⊁</p>

    <p class="intro-sum">Redefine Simplicity with your android experience on our minimalistic
      custom rom — where
      sleek design meets robust security, performance, and stability. Elevate your user interface with minimalist
      design and with the striking of perfect balanced customization options, customize with ease.
    </p>

    <br>

    <p>
      <a href="https://projectelixiros.com/download">
        <svg width="48" height="48" viewBox="0 0 24 24" fill="#00000000" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M17 17H17.01M17.4 14H18C18.9319 14 19.3978 14 19.7654 14.1522C20.2554 14.3552 20.6448 14.7446 20.8478 15.2346C21 15.6022 21 16.0681 21 17C21 17.9319 21 18.3978 20.8478 18.7654C20.6448 19.2554 20.2554 19.6448 19.7654 19.8478C19.3978 20 18.9319 20 18 20H6C5.06812 20 4.60218 20 4.23463 19.8478C3.74458 19.6448 3.35523 19.2554 3.15224 18.7654C3 18.3978 3 17.9319 3 17C3 16.0681 3 15.6022 3.15224 15.2346C3.35523 14.7446 3.74458 14.3552 4.23463 14.1522C4.60218 14 5.06812 14 6 14H6.6M12 15V4M12 15L9 12M12 15L15 12"
            stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </a>

      <a href="https://www.paypal.me/uglykid24"> <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38"
          fill="#000000" class="bi bi-paypal footer_logo_icons intro-icon" viewBox="0 0 16 16">
          <path
            d="M14.06 3.713c.12-1.071-.093-1.832-.702-2.526C12.628.356 11.312 0 9.626 0H4.734a.7.7 0 0 0-.691.59L2.005 13.509a.42.42 0 0 0 .415.486h2.756l-.202 1.28a.628.628 0 0 0 .62.726H8.14c.429 0 .793-.31.862-.731l.025-.13.48-3.043.03-.164.001-.007a.351.351 0 0 1 .348-.297h.38c1.266 0 2.425-.256 3.345-.91.379-.27.712-.603.993-1.005a4.942 4.942 0 0 0 .88-2.195c.242-1.246.13-2.356-.57-3.154a2.687 2.687 0 0 0-.76-.59l-.094-.061ZM6.543 8.82a.695.695 0 0 1 .321-.079H8.3c2.82 0 5.027-1.144 5.672-4.456l.003-.016c.217.124.4.27.548.438.546.623.679 1.535.45 2.71-.272 1.397-.866 2.307-1.663 2.874-.802.57-1.842.815-3.043.815h-.38a.873.873 0 0 0-.863.734l-.03.164-.48 3.043-.024.13-.001.004a.352.352 0 0 1-.348.296H5.595a.106.106 0 0 1-.105-.123l.208-1.32.845-5.214Z" />
        </svg> </a>

      <a href="https://twitter.com/Projectelixiros"> <svg xmlns="http://www.w3.org/2000/svg"
          shape-rendering="geometricPrecision" width="34" height="34" class="bi bi-paypal footer_logo_icons intro-icon"
          text-rendering="geometricPrecision" image-rendering="optimizeQuality" fill-rule="evenodd" clip-rule="evenodd"
          viewBox="0 0 512 462.799">
          <path fill-rule="nonzero"
            d="M403.229 0h78.506L310.219 196.04 512 462.799H354.002L230.261 301.007 88.669 462.799h-78.56l183.455-209.683L0 0h161.999l111.856 147.88L403.229 0zm-27.556 415.805h43.505L138.363 44.527h-46.68l283.99 371.278z" />
        </svg></a>

      <a href="https://www.buymeacoffee.com/Uglykid">
        <svg width="38" height="38" fill="#000000" class="bi footer_logo_icons intro-icon" viewBox="0 0 24 24"
          role="img" xmlns="http://www.w3.org/2000/svg">
          <path
            d="m20.216 6.415-.132-.666c-.119-.598-.388-1.163-1.001-1.379-.197-.069-.42-.098-.57-.241-.152-.143-.196-.366-.231-.572-.065-.378-.125-.756-.192-1.133-.057-.325-.102-.69-.25-.987-.195-.4-.597-.634-.996-.788a5.723 5.723 0 0 0-.626-.194c-1-.263-2.05-.36-3.077-.416a25.834 25.834 0 0 0-3.7.062c-.915.083-1.88.184-2.75.5-.318.116-.646.256-.888.501-.297.302-.393.77-.177 1.146.154.267.415.456.692.58.36.162.737.284 1.123.366 1.075.238 2.189.331 3.287.37 1.218.05 2.437.01 3.65-.118.299-.033.598-.073.896-.119.352-.054.578-.513.474-.834-.124-.383-.457-.531-.834-.473-.466.074-.96.108-1.382.146-1.177.08-2.358.082-3.536.006a22.228 22.228 0 0 1-1.157-.107c-.086-.01-.18-.025-.258-.036-.243-.036-.484-.08-.724-.13-.111-.027-.111-.185 0-.212h.005c.277-.06.557-.108.838-.147h.002c.131-.009.263-.032.394-.048a25.076 25.076 0 0 1 3.426-.12c.674.019 1.347.067 2.017.144l.228.031c.267.04.533.088.798.145.392.085.895.113 1.07.542.055.137.08.288.111.431l.319 1.484a.237.237 0 0 1-.199.284h-.003c-.037.006-.075.01-.112.015a36.704 36.704 0 0 1-4.743.295 37.059 37.059 0 0 1-4.699-.304c-.14-.017-.293-.042-.417-.06-.326-.048-.649-.108-.973-.161-.393-.065-.768-.032-1.123.161-.29.16-.527.404-.675.701-.154.316-.199.66-.267 1-.069.34-.176.707-.135 1.056.087.753.613 1.365 1.37 1.502a39.69 39.69 0 0 0 11.343.376.483.483 0 0 1 .535.53l-.071.697-1.018 9.907c-.041.41-.047.832-.125 1.237-.122.637-.553 1.028-1.182 1.171-.577.131-1.165.2-1.756.205-.656.004-1.31-.025-1.966-.022-.699.004-1.556-.06-2.095-.58-.475-.458-.54-1.174-.605-1.793l-.731-7.013-.322-3.094c-.037-.351-.286-.695-.678-.678-.336.015-.718.3-.678.679l.228 2.185.949 9.112c.147 1.344 1.174 2.068 2.446 2.272.742.12 1.503.144 2.257.156.966.016 1.942.053 2.892-.122 1.408-.258 2.465-1.198 2.616-2.657.34-3.332.683-6.663 1.024-9.995l.215-2.087a.484.484 0 0 1 .39-.426c.402-.078.787-.212 1.074-.518.455-.488.546-1.124.385-1.766zm-1.478.772c-.145.137-.363.201-.578.233-2.416.359-4.866.54-7.308.46-1.748-.06-3.477-.254-5.207-.498-.17-.024-.353-.055-.47-.18-.22-.236-.111-.71-.054-.995.052-.26.152-.609.463-.646.484-.057 1.046.148 1.526.22.577.088 1.156.159 1.737.212 2.48.226 5.002.19 7.472-.14.45-.06.899-.13 1.345-.21.399-.072.84-.206 1.08.206.166.281.188.657.162.974a.544.544 0 0 1-.169.364zm-6.159 3.9c-.862.37-1.84.788-3.109.788a5.884 5.884 0 0 1-1.569-.217l.877 9.004c.065.78.717 1.38 1.5 1.38 0 0 1.243.065 1.658.065.447 0 1.786-.065 1.786-.065.783 0 1.434-.6 1.499-1.38l.94-9.95a3.996 3.996 0 0 0-1.322-.238c-.826 0-1.491.284-2.26.613z" />
        </svg>
      </a>


      <a href="https://github.com/Project-Elixir"> <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40"
          fill="#000000" class="bi footer_logo_icons intro-icon" viewBox="0 0 16 16">
          <path
            d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.012 8.012 0 0 0 16 8c0-4.42-3.58-8-8-8z" />
        </svg> </a>
    </p>

    <h1 class="home-intro-btn"> <a href="https://projectelixiros.com/faq">
        <a class="btn footer-support-btn" style="letter-spacing: 2px;">
          Get to know us more <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="bi logo_icons"
            height="40" width="40">
            <path
              d="m18.707 12.707-3 3a1 1 0 0 1-1.414-1.414L15.586 13H6a1 1 0 0 1 0-2h9.586l-1.293-1.293a1 1 0 0 1 1.414-1.414l3 3a1 1 0 0 1 0 1.414z"
              style="fill:hsl(0, 0%, 100%)" data-name="Right" />
          </svg></a>
      </a></h1>

  </div>

  <!-- Homepage Image Header Section -->
  <div class="col-md-6 home_animation2">
    <img src="./assets/images/temp-download.png" class="card-img home-phone" alt="img">
  </div>

</div>

<ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="7769138215"
  style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto" data-full-width-responsive="true">
</ng2-adsense>

<br>

<!-- Announcement Card  -->
<!-- <div class="container card shadow-light website_animation"
  style="padding: 2rem; background-image: radial-gradient(circle at top left, #fff8ef 25%, #ffffff 25.5%, #ffffff 36%, white 37%, #ffd8b982 100%), radial-gradient(circle at bottom right, white 34%, #fff1f1 34.5%, #fff1f1 45.5%, white 46%, #ffbfbf14 100%); border: none;">
  <h2 class="card-title" style="margin-top: 1.5rem;">Alert! Announcement! ⚠️</h2>
  <br>
  <p class="card-text" style="margin-bottom: 1.5rem; font-weight: 500;">~ We would like to announce that our latest
    android version is Android 15 (QPR2) and
    stable release for officially supported device have started on patreon/bmc exclusively. What about Android 14 ? Well
    sadly we have to discontinue it as we have all shifted to Android 15.
  </p>

  <a target="_blank" href="https://www.patreon.com/posts/introducing-now-120739925">
    <p> <a class="btn shadow patreon-btn" style="display: inline-block;">
        <svg width="22" height="22" viewBox="0 -4.5 256 256" version="1.1" class="bi bi-patreon"
          xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid">
          <g>
            <path
              d="M45.1355837,0 L45.1355837,246.35001 L0,246.35001 L0,0 L45.1355837,0 Z M163.657111,0 C214.65668,0 256,41.3433196 256,92.3428889 C256,143.342458 214.65668,184.685778 163.657111,184.685778 C112.657542,184.685778 71.3142222,143.342458 71.3142222,92.3428889 C71.3142222,41.3433196 112.657542,0 163.657111,0 Z"
              fill="#ffffff"></path>
          </g>
        </svg> Active devices on Patreon
      </a>
    </p>
  </a>

</div> -->

<!-- Home Page Body except Name and Phone Image on Top -->
<div class="container-fliud">

  <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="7769138215"
    style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto" data-full-width-responsive="true">
  </ng2-adsense>

  <div class="website_animation">

    <!-- Astonishing Features Container -->
    <div>
      <h1 class="features"> Features that makes AOSP <strong class="key-high">exciting</strong> </h1>
    </div>

    <div class="card mb-3 features_card container ">
      <div class="row no-gutters feature_img">
        <div class="col-md-4">
          <img src="./assets/images/feature-depth_img.png" class="card-img faq depthfeatures-img" alt="img">
        </div>
        <div class="col-md-8" style="margin-top: 0.7rem;">
          <div class="card-body">
            <h5 class="card-title f_head2 "><strong class="muted_text">iOS inspired</strong> automated depth clocks</h5>
            <p class="card-text ">Depth Effect ensures a small part of the wallpaper subject appears behind the Lock
              Screen clock, creating a nice visual style. It makes it look like the wallpaper has depth by placing the
              clock in front of the image's foreground. The subject of the photo needs to be cut out for the wallpaper
              to be placed in front of the clock. <strong>We are the 1st ROM to introduce automated depth clocks just
                like iOS.</strong> Our implementation provides you automatic
              depth clock without any hassle to set subject separately. It is well defined and polished in terms of
              animation as well as notification. You can set any depth wallpaper you want just make sure to use proper
              wallpaper to get the best results. </p>
            <!-- <p style="font-style: italic;">“Elegance is the only beauty that never fades.” <strong class="muted_text">-
                Audrey Hepburn</strong></p> -->

          </div>
        </div>
      </div>
    </div>

    <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="7769138215"
      style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto" data-full-width-responsive="true">
    </ng2-adsense>

    <div class="card mb-3 features_card container ">
      <div class="row no-gutters feature_img">

        <div class="col-md-8" style="margin-top: 2.5rem;">
          <div class="card-body">
            <h5 class="card-title f_head2 "><strong class="muted_text">Built for</strong> stock experience</h5>
            <p class="card-text ">Customization is paramount to productivity. The purest version of Android is
              colloquially known as AOSP, which references the
              Android Open-Source Project. We have researched that users (people) prefer stock experience with a
              UI enhancement instead of fully
              customised experience so we implemented every small detail of stock pixel that make your experience
              enjoyable with elixir touch. Everyone is unique and your device should be too. </p>
            <!-- <p style="font-style: italic;">“Elegance is the only beauty that never fades.” <strong class="muted_text">-
                Audrey Hepburn</strong></p> -->
          </div>
        </div>

        <div class="col-md-4">
          <img src="./assets/images/feature1_img.webp" class="card-img faq features-img" alt="img">
        </div>

      </div>
    </div>

    <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="7769138215"
      style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto" data-full-width-responsive="true">
    </ng2-adsense>

    <div class="card mb-3 features_card container">
      <div class="row no-gutters feature_img">

        <div class="col-md-4">
          <img src="./assets/images/feature6_img.webp" class="card-img faq features-img" alt="img">
        </div>

        <div class="col-md-8" style="margin-top: 2.3rem;">
          <div class="card-body">
            <h5 class="card-title f_head2 "><strong class="muted_text">Ready for</strong> daily use</h5>
            <p class="card-text ">We are discovering every small aspect and implementing them to make your experience
              with Project Elixir awesome and reliable, our all features are tested by many testers and
              developers to give you an effortless and seamless experience everytime. Make each day your masterpiece.
            </p>
            <!-- <p style="font-style: italic;"> “It's not a faith in technology. It's faith in people.” <strong
                class="muted_text">- Steve Jobs</strong></p> -->
          </div>
        </div>

      </div>
    </div>

    <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="7769138215"
      style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto" data-full-width-responsive="true">
    </ng2-adsense>

    <div class="card mb-3 features_card container">
      <div class="row no-gutters feature_img">

        <div class="col-md-8" style="margin-top: 1.5rem;">
          <div class="card-body">
            <h5 class="card-title f_head2 "><strong class="muted_text">Made by </strong>experienced developers </h5>
            <p class="card-text">As an experienced developers, we are finding every build error and fixing them
              before the
              device maintainer
              build for your device so as a user you don't need to worry about build problem, if you get any bugs or
              flashing issues
              feel
              free to contact us on our telegram group with proper logs, we assure you that you will get solution with
              best
              possible
              way. </p>
            <!-- <p style="font-style: italic;">“Innovation is the outcome of a habit, not a random act.” <strong
                class="muted_text">- Sukant Ratnakar</strong></p> -->
          </div>
        </div>

        <div class="col-md-4">
          <img src="./assets/images/feature5_img.webp" class="card-img faq features-img" alt="img">
        </div>

      </div>
    </div>

    <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="7769138215"
      style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto" data-full-width-responsive="true">
    </ng2-adsense>

    <div class="card mb-3 features_card container">
      <div class="row no-gutters feature_img">

        <div class="col-md-4">
          <img src="./assets/images/feature3_img.webp" class="card-img faq" alt="img">
        </div>

        <div class="col-md-8" style="margin-top: 0.5rem;">
          <div class="card-body">
            <h5 class="card-title f_head2 "><strong class="muted_text">Colourful user interface with</strong> Monet
              engine</h5>
            <p class="card-text ">The “monet” theme engine is where the magic happens when it comes to Material You,
              and
              it’s the algorithm that decides what colors are selected from a wallpaper. When a user changes their
              wallpaper on Project Elixir, the image is analyzed to select a color and algorithmically choose Primary,
              Secondary colors using an initial seed color. Two neutral colors are also chosen which give Material You
              its overall tint. </p>
            <!-- <p style="font-style: italic;">“Simplicity is the ultimate sophistication.” <strong class="muted_text">-
                Leonardo da Vinci</strong></p> -->
          </div>
        </div>

      </div>
    </div>

    <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="7769138215"
      style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto" data-full-width-responsive="true">
    </ng2-adsense>

    <div class="card mb-3 features_card container">
      <div class="row no-gutters feature_img">

        <div class="col-md-8" style="margin-top: 1.5rem;">
          <div class="card-body">
            <h5 class="card-title f_head2 ">Security and Privacy <strong class="muted_text">is our priority</strong>
            </h5>
            <p class="card-text ">Your data, your rules. Project Elixir is a privacy and security-focused mobile OS. We
              believe that features
              can be designed in such a way that they're always gaurding you without impacting the user experience.
              Along with monthly security updates to every supported device. We have added more user options like Face
              Unlock, App Hide & lock & restrictions, grid pattern and scramble pin, Selinux Enforcing, Secure Quick
              Settings & USB peripherals, camera, quick tiles, etc along with more complex user-facing privacy and
              security features. in our updates. Trust is a system helps you
              understand the state of your device's security and warns you about possible threats. </p>
            <!-- <p style="font-style: italic;">“To be left alone is the most precious thing one can ask of the modern
              world.” <strong class="muted_text">- Anthony Burgess</strong></p> -->
          </div>
        </div>

        <div class="col-md-4">
          <img src="./assets/images/feature2_img.webp" class="card-img faq features-img" alt="img">
        </div>

      </div>
    </div>

    <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="7769138215"
      style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto" data-full-width-responsive="true">
    </ng2-adsense>

    <div class="card mb-3 features_card container">
      <div class="row no-gutters feature_img">

        <div class="col-md-4">
          <img src="./assets/images/feature4_img.webp" class="card-img faq features-img" alt="img">
        </div>

        <div class="col-md-8" style="margin-top: 2.3rem;">
          <div class="card-body">
            <h5 class="card-title f_head2 "><strong class="muted_text">Routine system</strong> updates and support
            </h5>
            <p class="card-text ">Keep your mobile up-to-date, safely and quickly Upgrade to the latest software
              available for your phone, and enjoy enhancements like new features, extra speed, improved functionality,
              and also fixed bugs. We ensure monthly updates with Project Elixir, we provide you updates with Elixir
              Updater. Feel free to join our patreon for exclusive and early build access.</p>
            <!-- <p style="font-style: italic;">"A brand for a company is like a reputation for a person. You earn a
              reputation by trying to do hard things well." <strong class="muted_text">- Jeff Bezos</strong></p> -->
          </div>
        </div>

      </div>
    </div>

    <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="7769138215"
      style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto" data-full-width-responsive="true">
    </ng2-adsense>

    <!-- ScreenShot Container -->
    <app-gallery></app-gallery>
    <div class="container">
      <h2 style="font-weight: 600;">For more such amazing <strong class="key-high">sneak peak</strong> do checkout</h2>
      <a href="https://projectelixiros.com/gallery">
        <a class="btn shadow archive-btn">Our Gallery</a>
      </a>
    </div>


    <!-- <div class="container shadow-light rounded" style="background: white;">

      <div class="card-deck">

        <div class="card p-3 mb-5 bg-body rounded">
          <img class="card-img-top ss" src="./assets/images/s1.webp" alt="Card image cap">
          <div class="card-body">
            <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="1318280513"
              style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto"
              data-full-width-responsive="true">
            </ng2-adsense>
            <h1><a href="https://projectelixiros.com/gallery">
                <a class="btn shadow device-btn">View More</a>
              </a></h1>
          </div>
        </div>
        <div class="card p-3 mb-5 bg-body rounded">
          <img class="card-img-top ss" src="./assets/images/s2.webp" alt="Card image cap">
          <div class="card-body">
            <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="1318280513"
              style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto"
              data-full-width-responsive="true">
            </ng2-adsense>
            <h1><a href="https://projectelixiros.com/gallery">
                <a class="btn shadow device-btn">View More</a>
              </a></h1>
          </div>
        </div>
        <div class="card p-3 mb-5 bg-body rounded">
          <img class="card-img-top ss" src="./assets/images/s3.webp" alt="Card image cap">
          <div class="card-body">
            <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="1318280513"
              style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto"
              data-full-width-responsive="true">
            </ng2-adsense>
            <h1><a href="https://projectelixiros.com/gallery">
                <a class="btn shadow device-btn">View More</a>
              </a></h1>
          </div>
        </div>

      </div>

    </div> -->

    <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="7769138215"
      style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto" data-full-width-responsive="true">
    </ng2-adsense>

    <br>

    <!-- About Team Container -->
    <div>
      <h1 class="features"> Here are the <strong class="key-high">minds</strong> behind Elixir </h1>
    </div>
    <app-team></app-team>

    <h1 class="features"> Find a carpet that matches your <strong class="key-high">device</strong>
    </h1>

    <!-- Download Container -->
    <div class="container shadow-light rounded" style="background: white;">

      <div class="mb-align" style="text-align: center; padding-top: 2rem;">
        <img src="./assets/images/download_carpet.webp" class="card-img img-fluid down-carpet-img" alt="avatar">
      </div>

      <div class="row justify-content-center">
        <div class="container card-radius">
          <div class="row no-gutters">

            <div class="col-md-6 mb-align">
              <img src="./assets/images/download.webp" class="card-img img-fluid down-info-img" alt="avatar">
              <p class="count-head"> Downloads</p>
              <h4 class="muted_text" style="font-family: 'monospace'">Total number of Downloads</h4>
              <p class="count-body">1M+</p>
            </div>

            <div class="col-md-6 mb-align">
              <img src="./assets/images/devices.webp" class="card-img img-fluid down-info-img" alt="avatar">
              <p class="count-head"> Devices</p>
              <h4 class="muted_text" style="font-family: 'monospace'">Total number of Official Devices</h4>
              <p class="count-body">70+</p>
            </div>

          </div>
        </div>
      </div>


      <div class="row justify-content-center">
        <div class=" mb-3 card-radius">
          <div class="row no-gutters">

            <div class="">
              <div class="card-body">

                <p class="down-carp_head">Say Goodbye to Snail Mode, Switch to Elixir <strong class="key-high">Fast
                    Lane</strong></p>

                <h1 class="home-intro-btn"> <a href="https://projectelixiros.com/download">
                    <a class="btn shadow footer-support-btn">
                      Download Now</a>
                  </a></h1>

              </div>

              <br>

            </div>

          </div>
        </div>
      </div>
    </div>

    <br>
    <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="7769138215"
      style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto" data-full-width-responsive="true">
    </ng2-adsense>

    <!-- Donate Container -->
    <div>
      <h1 class="features"> <strong class="key-high">Support</strong> the minds for their Hardwork </h1>
    </div>
    <app-donate></app-donate>

    <div>
      <h1 class="features"> Important platforms to <strong class="key-high">connect</strong> with us </h1>
    </div>

    <!-- FAQ Container -->
    <div class="container Important-platforms">
      <div class="row justify-content-center">
        <div class="card-radius">
          <div class="row no-gutters">

            <div class="col-md-6 mb-align">
              <img src="./assets/images/faq-home.webp" class="card-img img-fluid down-carpet-img" style="padding: 2rem;"
                alt="avatar">
            </div>

            <div class="col-md-6">
              <div class="card-body">
                <h1 class="connect_head"> Your <strong class="key-high">Questions</strong> are answered here </h1>
                <p style="font-style: italic;">“The only true wisdom is in knowing that you know nothing." <strong
                    class="muted_text">
                    - Socrates</strong></p>

                <h1> <a href="https://projectelixiros.com/faq">
                    <a class="btn shadow footer-support-btn">Frequently Asked Questions</a>
                  </a></h1>

              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <br>
    <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="7769138215"
      style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto" data-full-width-responsive="true">
    </ng2-adsense>

    <!-- Twitter Container -->
    <div class="container Important-platforms">
      <div class="row justify-content-center">
        <div class="card-radius">
          <div class="row no-gutters">

            <div class="col-md-8">
              <div class="card-body">
                <h1 class="connect_head"> Connect with us on <strong class="key-high">Twitter</strong></h1>
                <p>Come join us in our journey on twitter and tag us with your experience of using Project Elixir in
                  your device!</p>
                <h1> <a target="_blank" href="https://twitter.com/Projectelixiros">
                    <a class="btn shadow footer-support-btn">Our Twitter Handle</a>
                  </a></h1>

              </div>
            </div>

            <div class="col-md-4 mb-align">
              <img src="./assets/images/twitter.webp" class="card-img img-fluid down-carpet-img" style="padding: 2rem;"
                alt="avatar">
            </div>

          </div>
        </div>
      </div>
    </div>

    <br>
    <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="7769138215"
      style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto" data-full-width-responsive="true">
    </ng2-adsense>

    <!-- Telegram Container -->
    <div class="container Important-platforms">
      <div class="row justify-content-center">
        <div class="card-radius">
          <div class="row no-gutters">

            <div class="col-md-4 mb-align">
              <img src="./assets/images/telegram.webp" class="card-img img-fluid down-carpet-img" style="padding: 2rem;"
                alt="avatar">
            </div>

            <div class="col-md-8">
              <div class="card-body">
                <h1 class="connect_head">Join our <strong class="key-high">Telegram</strong> channel for support</h1>
                <p>Our Telegram chat support offers the following support: Update channel, friendly community, forum
                  support and self-service support.</p>

                <h1 class="home-intro-btn"> <a target="_blank" href="https://telegram.me/Elixir_Updates">
                    <a class="btn shadow footer-support-btn"> Update Channel</a>
                  </a></h1>

                <h1 class="home-intro-btn"> <a target="_blank" href="https://telegram.me/Elixir_Discussion">
                    <a class="btn shadow footer-support-btn"> Discussion Group</a>
                  </a></h1>

              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <br>
    <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="7769138215"
      style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto" data-full-width-responsive="true">
    </ng2-adsense>

    <!-- Github Container -->
    <div class="container Important-platforms">
      <div class="row justify-content-center">
        <div class="card-radius">
          <div class="row no-gutters">

            <div class="col-md-8">
              <div class="card-body">
                <h1 class="connect_head">Checkout <strong class="key-high">Github</strong> for our source code</h1>
                <p>GitHub is an online software development platform. It's used for storing, tracking, and
                  collaborating on software projects. It makes it easy for developers to share code files and
                  collaborate with fellow developers on open-source projects.</p>
                <h1> <a target="_blank" href="https://github.com/Project-Elixir">
                    <a class="btn shadow footer-support-btn">Source Code</a>
                  </a></h1>

              </div>
            </div>

            <div class="col-md-4 mb-align">
              <img src="./assets/images/github.webp" class="card-img img-fluid down-carpet-img" style="padding: 2rem;"
                alt="avatar">
            </div>

          </div>
        </div>
      </div>
    </div>

    <br>
    <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="7769138215"
      style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto" data-full-width-responsive="true">
    </ng2-adsense>

    <!-- Translation Container -->
    <!-- <div class="container mb-3 shadow-light rounded Important-platforms" style="background: white; padding: 1rem;">
      <div class="row justify-content-center">
        <div class="card-radius">
          <div class="row no-gutters">

            <div class="col-md-4 mb-align">
              <img src="./assets/images/translation.webp" class="card-img img-fluid down-carpet-img" alt="avatar">
            </div>

            <div class="col-md-8">
              <div class="card-body">
                <h1 class="connect_head">Help us to <strong class="key-high">translate</strong> our ROM</h1>
                <p>We aim to provide our users Project Elixir with their local languages so that they'll be more
                  comfortable in using our ROM daily</p>

                <h1> <a href="https://crowdin.com/project/project-elixir">
                    <a class="btn shadow footer-support-btn">Crowdin Page</a>
                  </a></h1>

              </div>
            </div>

          </div>
        </div>
      </div>
    </div> -->

    <br>
    <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="7769138215"
      style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto" data-full-width-responsive="true">
    </ng2-adsense>

    <!-- <div>
      <h1 class="features"> OFF - Topic <strong class="key-high">Highlights</strong> </h1>
    </div> -->

    <!-- Youtube Channel -->
    <!-- <div class="card mb-3 Important-platforms container ">
      <div class="row no-gutters" style="text-align: center;">

        <div class="col-md-4">
          <img src="./assets/images/youtube.webp" class="card-img faq" alt="img">
        </div>

        <div class="col-md-8" style="margin-top: 1rem;">
          <div class="card-body">
            <h5 class="card-title f_head2 ">Subscribe & Share<strong class="muted_text"> will
                be really appreciate
              </strong></h5>
            <p class="card-text">Long story short, my friends and I have been travelling in India for the last couple
              of
              years. So we
              decided to create a YouTube channel for fun to drop our experience and share our little world in shorts
              and
              small videos.</p>
            <p class="card-text">Our videos consist of spontaneous vacations from our life. With an emphasis on
              traveling, personal health
              & well-being, these vlogs are meant to encourage everyone to go out, explore, and make the most out of
              every situation they come across.</p>
            <a target="_blank" href="https://www.youtube.com/channel/UCEq3paOdI2-0z6q4gw3QHgg">
              <a class="btn shadow footer-support-btn">Subscribe Now</a>
            </a>

          </div>
        </div>

      </div>
    </div>

    <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="7769138215"
      style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto" data-full-width-responsive="true">
    </ng2-adsense> -->

    <!-- Website Credits -->
    <div>
      <h3 style="text-align: center; margin-top: 6rem; font-weight: 600; padding: 0 1rem;">Have some amazing <strong
          class="key-high">ideas for improving</strong> this website?</h3>
      <h3 style="text-align: center; padding: 0 1rem; font-size: 1.2rem;">Feel free to connect us via email</h3>
    </div>

    <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="7769138215"
      style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto" data-full-width-responsive="true">
    </ng2-adsense>

    <!-- Website Developer -->
    <!-- <div class="container mb-5 bg-body rounded feature_img features_card"
      style="padding: 2rem; background-color: white;">
      <div class="row justify-content-center">
        <div class=" mb-3 card-radius">
          <div class="row no-gutters">

            <div class="col-md-8">
              <div class="card-body info_card">
                <h1 class="support_line"> Tulika </h1>
                <p class="patreon_highlight">Front-End Developer</p>

                <a target="_blank" href="https://github.com/pixie-codes">
                  <svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" fill="#e77d5a" class="bi bi-github"
                    viewBox="0 0 16 16">
                    <path
                      d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.012 8.012 0 0 0 16 8c0-4.42-3.58-8-8-8z" />
                  </svg>
                </a>

                <a target="_blank" href="https://www.linkedin.com/in/tulika-ghosh/">
                  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" class="bi bi-twitter mtqL2 "
                    viewBox="7.025 7.025 497.951 497.95">
                    <path fill="#e77d5a"
                      d="M256 7.025C118.494 7.025 7.025 118.494 7.025 256S118.494 504.975 256 504.975 504.976 393.506 504.976 256C504.975 118.494 393.504 7.025 256 7.025zm-66.427 369.343h-54.665V199.761h54.665v176.607zM161.98 176.633c-17.853 0-32.326-14.591-32.326-32.587 0-17.998 14.475-32.588 32.326-32.588s32.324 14.59 32.324 32.588c.001 17.997-14.472 32.587-32.324 32.587zm232.45 199.735h-54.4v-92.704c0-25.426-9.658-39.619-29.763-39.619-21.881 0-33.312 14.782-33.312 39.619v92.704h-52.43V199.761h52.43v23.786s15.771-29.173 53.219-29.173c37.449 0 64.257 22.866 64.257 70.169l-.001 111.825z" />
                  </svg>
                </a>

                <a target="_blank" href="https://telegram.me/pixiecodes">
                  <svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" fill="#e77d5a" class="bi bi-telegram "
                    viewBox="0 0 16 16">
                    <path
                      d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.287 5.906c-.778.324-2.334.994-4.666 2.01-.378.15-.577.298-.595.442-.03.243.275.339.69.47l.175.055c.408.133.958.288 1.243.294.26.006.549-.1.868-.32 2.179-1.471 3.304-2.214 3.374-2.23.05-.012.12-.026.166.016.047.041.042.12.037.141-.03.129-1.227 1.241-1.846 1.817-.193.18-.33.307-.358.336a8.154 8.154 0 0 1-.188.186c-.38.366-.664.64.015 1.088.327.216.589.393.85.571.284.194.568.387.936.629.093.06.183.125.27.187.331.236.63.448.997.414.214-.02.435-.22.547-.82.265-1.417.786-4.486.906-5.751a1.426 1.426 0 0 0-.013-.315.337.337 0 0 0-.114-.217.526.526 0 0 0-.31-.093c-.3.005-.763.166-2.984 1.09z" />
                  </svg>
                </a>
              </div>
            </div>

            <div class="col-md-4 mb-align" style="text-align: center;">
              <img src="./assets/images/pixie_avatar.webp" class="card-img img-fluid web-dev-img" alt="avatar">
            </div>

          </div>
        </div>
      </div>
    </div> -->

    <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="7769138215"
      style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto" data-full-width-responsive="true">
    </ng2-adsense>

    <!-- scroll to top -->
    <div class="scroll-to-top" [ngClass]="{'show-scrollTop': windowScrolled}">
      <button type="button" class="btn active scroll-btn" data-toggle="button" aria-pressed="true"
        (click)="scrollToTop()">
        <i class="fas fa-chevron-up"></i>
      </button>
    </div>

  </div>
</div>

<!-- Footer Support Card -->
<div class="bg-body" style="background-color: #ffebda; padding: 2rem; margin-bottom: -2rem;">
  <div class="row justify-content-center">
    <div class=" mb-3 card-radius">
      <div class="row no-gutters">

        <div class="col-md-6">
          <div class="card-body">
            <h1 class="support_line"> Wanna Support Us ? </h1>
            <p class="patreon_highlight">Help to keep Project Elixir active and running by donating. Any
              amount is appreciated. <strong>シ </strong>
            </p>
            <h1> <a href="https://projectelixiros.com/donate">
                <a class="btn shadow footer-support-btn">Donate Now</a>
              </a></h1>

          </div>
        </div>

        <div class="col-md-6 mb-align" style="text-align: center;">
          <img src="./assets/images/donate-phone-hand.webp" class="card-img img-fluid down-carpet-img"
            style="width: 15rem;" alt="avatar">
        </div>

      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>